import React, { lazy, useEffect, useState } from "react";
import "../CampaignStep.css";
import Step4Card from "../../StepsCard/Step4Card/Step4Card";
import { useSelector } from "react-redux";
import { PuffLoader } from "react-spinners";
import UNIVERSAL from "../../../../config/config";

const CampaignStep4 = ({ pricingData, loading }) => {
  const campaigns = useSelector((state) => state.campaigns.data);
  const [businessInfo, setBusinessInfo] = useState("");

  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    async function getBrandData() {
      return fetch(UNIVERSAL.BASEURL_2 + "/user/api/v1/business/info", {
        method: "POST",
        body: JSON.stringify({
          business_id: user?.app_business_id,
        }),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson?.data?.brand_name === null || responseJson?.data?.brand_name?.length === 0) {
          } else {
            if (responseJson?.data) setBusinessInfo(responseJson.data);
          }
        })
        .finally(() => {})
        .catch((error) => {
          console.log(error);
        });
    }
    getBrandData();
  }, []);

  console.log(businessInfo);

  return (
    <div className="campaignStep4">
      {loading && (
        <div style={{ display: "flex", width: "100%", height: "15rem", justifyContent: "center", alignItems: "center" }}>
          <PuffLoader size={70} color="#4FC3F7" />
        </div>
      )}
      <div id="step4Cards">
        {businessInfo?.source?.toUpperCase() === "INTERAKT" && businessInfo?.credits >= pricingData[0].campaign_budget ? (
          <>
            {!campaigns?.length &&
              !loading &&
              pricingData?.slice(0, 1)?.map((data, index) => {
                return <Step4Card data={data} key={index} step4Data={pricingData} />;
              })}
            {!loading &&
              campaigns?.length !== 0 &&
              pricingData?.slice(1)?.map((data, index) => {
                return <Step4Card data={data} key={index} step4Data={pricingData} />;
              })}
          </>
        ) : (
          pricingData?.map((data, index) => {
            return <Step4Card data={data} key={index} step4Data={pricingData} />;
          })
        )}
      </div>
    </div>
  );
};

export default CampaignStep4;
